export type FloorCoveringTypesProps = {
  hasCarpet: boolean;
  hasConcrete: boolean;
  hasHardwood: boolean;
  hasLaminate: boolean;
  hasLinoleum: boolean;
  hasSlate: boolean;
  hasSoftwood: boolean;
  hasTile: boolean;
  hasVinyl: boolean;
};

const FloorCoveringTypes = ({
  hasCarpet = false,
  hasConcrete = false,
  hasHardwood = false,
  hasLaminate = false,
  hasLinoleum = false,
  hasSlate = false,
  hasSoftwood = false,
  hasTile = false,
  hasVinyl = false,
}: Partial<FloorCoveringTypesProps> = {}): FloorCoveringTypesProps => ({
  hasCarpet: Boolean(hasCarpet),
  hasConcrete: Boolean(hasConcrete),
  hasHardwood: Boolean(hasHardwood),
  hasLaminate: Boolean(hasLaminate),
  hasLinoleum: Boolean(hasLinoleum),
  hasSlate: Boolean(hasSlate),
  hasSoftwood: Boolean(hasSoftwood),
  hasTile: Boolean(hasTile),
  hasVinyl: Boolean(hasVinyl),
});

export default FloorCoveringTypes;
